import amsterdamImage from '@/assets/images/amsterdam.jpg';
import australiaImage from '@/assets/images/australia.jpg';
import canadaImage from '@/assets/images/canada.jpg';
import hawaiiImage from '@/assets/images/hawaii.jpg';
import londonImage from '@/assets/images/london.jpg';
import newzealandImage from '@/assets/images/newzealand.jpg';
import puertoRicoImage from '@/assets/images/puerto-rico.jpg';
import usaImage from '@/assets/images/usa.jpg';

export interface Coordinates {
  lat: number;
  lng: number;
}

export interface RegionCard {
  region: string;
  imagepath: string;
  searchQuery: string;
  ne: Coordinates;
  sw: Coordinates;
}

export const cards: RegionCard[] = [
  {
    region: 'United States of America',
    imagepath: usaImage,
    searchQuery: 'United States',
    ne: { lat: 72.7087158, lng: -66.3193754 },
    sw: { lat: 15.776013899999999, lng: -173.2992296 },
  },
  {
    region: 'Hawaii',
    imagepath: hawaiiImage,
    searchQuery: 'Hawaii',
    ne: { lat: 22.37, lng: -154.48 },
    sw: { lat: 18.55, lng: -160.53 },
  },
  {
    region: 'Puerto Rico',
    imagepath: puertoRicoImage,
    searchQuery: 'Puerto Rico',
    ne: { lat: 18.59895047151739, lng: -65.21057154202023 },
    sw: { lat: 17.84491905074946, lng: -68.11955568723072 },
  },
  {
    region: 'Amsterdam',
    imagepath: amsterdamImage,
    searchQuery: 'Amsterdam',
    ne: { lat: 52.4624825, lng: 5.079161944314914 },
    sw: { lat: 52.278174006469186, lng: 4.586594799999998 },
  },
  {
    region: 'Canada',
    imagepath: canadaImage,
    searchQuery: 'Canada',
    ne: { lat: 70, lng: -50 },
    sw: { lat: 42, lng: -142 },
  },
  {
    region: 'United Kingdom',
    imagepath: londonImage,
    searchQuery: 'United Kingdom',
    ne: { lat: 61.5471111, lng: 9.5844157 },
    sw: { lat: 47.5554486, lng: -18.5319589 },
  },
  {
    region: 'Australia',
    imagepath: australiaImage,
    searchQuery: 'Australia',
    ne: { lat: -0.6911343999999999, lng: 166.7429167 },
    sw: { lat: -51.66332320000001, lng: 100.0911072 },
  },
  {
    region: 'New Zealand',
    imagepath: newzealandImage,
    searchQuery: 'New Zealand',
    ne: { lat: -29.03025358336848, lng: -175.54850604321942 },
    sw: { lat: -52.81941716520193, lng: 165.55632342949164 },
  },
];
